import { useContext } from "react";
import { userOnboardingContext } from "../../states/context/userOnboardingContext";
import { styled } from '@mui/material/styles';
import ObjectivesChallengesCheckList from "./common/ObjectivesChallengesCheckList";

const MainContainer = styled('div')(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  marginLeft: "108px",
}));

const ObjHeading = styled('h3')(({ theme }) => ({
  fontSize: "20px",
  fontWeight: "600",
  marginTop: '40px',
  marginBottom: '16px',
}));

const LeftContainer = styled('div')(({ theme }) => ({
  marginRight: "63px",
}));

const HeaderContainer = styled('div')(({ theme }) => ({
  marginTop: "80px",
}));

const WelcomeHeading = styled('h2')(({ theme }) => ({
  fontSize: "32px",
  fontWeight: "600",
  fontFamily: "Figtree",
  marginTop: 0,
  marginBottom: "24px",
}));

const HeadPara = styled('p')(({ theme }) => ({
  fontSize: "16px",
  fontWeight: "400",
  color: "#747474",
  margin: 0,
}));

const Challenges = () => {
  const { user } = useContext(userOnboardingContext);
  const { challenges } = user;

  return (
    <MainContainer>
      <LeftContainer>
        <HeaderContainer>
          <WelcomeHeading>Welcome to Kavida.ai</WelcomeHeading>
          <HeadPara>
            Help us <b>build your personalize AI agent</b> by telling us a
            little bit about yourself, the challenges you are facing, and your
            goals.
          </HeadPara>
        </HeaderContainer>
        <div>
          <ObjHeading>
            What challenges are you facing in your current role?
          </ObjHeading>
          <p style={{ color: "#747474", margin: 0 }}>
            Select all that apply from the list below, and add any other
            challenges that's not included in the list below. The more specific
            you are, the better Agent PO can assist.
          </p>
        </div>
        <ObjectivesChallengesCheckList
          itemList={challenges}
          addBtnText="challenge"
        />
      </LeftContainer>
    </MainContainer>
  );
};

export default Challenges;
